package com.vizio.redwolf.utils.clientprovider

import com.vizio.redwolf.utils.BuildConfig
import com.vizio.redwolf.utils.Platform
import com.vizio.redwolf.utils.platform
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.DefaultRequest
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.request.headers
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpMessageBuilder
import io.ktor.serialization.kotlinx.json.json
import io.ktor.util.AttributeKey
import kotlinx.serialization.json.Json

interface ClientProvider {
    val httpClient: HttpClient
    val lazyClientInitDelegate: Lazy<HttpClient>
    fun close()
}

abstract class ConfigurableClientProvider : ClientProvider {
    fun updateLogLevel(logLevel: LogLevel) {
        if (lazyClientInitDelegate.isInitialized()) {
            httpClient.config {
                install(Logging) {
                    level = logLevel
                }
            }
        }
    }
}

private val configurableProviders: List<ConfigurableClientProvider>
    get() {
        val commonPlatformClientProviders = listOf(DefaultClientProvider, CookieClientProvider, BasicClientProvider)
        return when (platform) {
            Platform.Android, Platform.iOS -> commonPlatformClientProviders + UploadClientProvider + SSLSkipClientProvider
            Platform.JS -> commonPlatformClientProviders
        }
    }

object LogLevelConfig {
    var logLevel: LogLevel = LogLevel.NONE
        set(value) {
            field = value
            configurableProviders.forEach { it.updateLogLevel(value) }
        }
}

fun HttpClientConfig<*>.installCoreClientConfig() {
    expectSuccess = false // Do no throw exception, if status code is not success(>=300).
    install(Logging) {
        level = LogLevelConfig.logLevel
    }
    install(HttpTimeout)
    install(ContentNegotiation) {
        json(Json {
            coerceInputValues = true
            isLenient = true
            ignoreUnknownKeys = true
        })
    }
}

fun HttpMessageBuilder.addSdkHeaders() {
    headers {
        append("platform", platform.apiName)
        append("sdk-version", BuildConfig.SDK_VERSION)
        when (platform) {
            Platform.iOS -> append(HttpHeaders.UserAgent, "VizioiOS")
            Platform.Android -> append(HttpHeaders.UserAgent, "VizioAndroid")
            Platform.JS -> Unit // no-op, Browse will set User-Agent
        }
        if ((BuildConfig.AGENT_RW_CI_CD == BuildConfig.VIZIO_REDWOLF_CI_CD)) append("User-Agent", BuildConfig.VIZIO_REDWOLF_CI_CD)
    }
}

fun DefaultRequest.DefaultRequestBuilder.addCredentialsInclude() {
    setAttributes {
        put(AttributeKey("credentials"), "INCLUDE")
    }
}
